import { render } from "./tank.vue?vue&type=template&id=fe4f10a4"
import script from "./tank.vue?vue&type=script&lang=js"
export * from "./tank.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/components/tank.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe4f10a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe4f10a4', __exports__)) {
    console.log('reload')
    api.reload('fe4f10a4', __exports__)
  }
  
  module.hot.accept("./tank.vue?vue&type=template&id=fe4f10a4", () => {
    console.log('re-render')
    api.rerender('fe4f10a4', render)
  })

}


export default __exports__